module.exports = __webpack_public_path__ + "static/img/logo.769e0c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/logo.png
// module id = h0Al
// module chunks = 0